import React, { useState } from 'react';
import {
  Box,
  Popover,
  ButtonBase,
  Typography,
} from '@mui/material';

// Kuratierte Emoji-Liste, gruppiert nach thematischer Nutzung für Transkript-Aktionen.
const EMOJI_GROUPS = [
  {
    label: 'Dokumente & Notizen',
    emojis: ['📝', '📄', '📋', '🗒️', '📑', '📊', '📈', '🧾'],
  },
  {
    label: 'Entscheidung & Aktion',
    emojis: ['✅', '☑️', '✔️', '⚖️', '🎯', '🚩', '⚡', '🔥'],
  },
  {
    label: 'Ideen & Wissen',
    emojis: ['💡', '🧠', '🔍', '🔎', '📚', '🎓', '🧩', '✨'],
  },
  {
    label: 'Kommunikation',
    emojis: ['💬', '🗣️', '📣', '📢', '📬', '📞', '🤝', '👥'],
  },
  {
    label: 'Zeit & Aufgaben',
    emojis: ['⏱️', '⏰', '📅', '📆', '⌛', '🕐', '🧭', '🛠️'],
  },
];

export default function EmojiPicker({ value, onChange }) {
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  const pick = (emoji) => {
    onChange?.(emoji);
    setAnchor(null);
  };

  return (
    <>
      <ButtonBase
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          width: 56,
          height: 56,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          fontSize: 28,
          bgcolor: 'background.paper',
          '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
        }}
        aria-label="Icon auswählen"
      >
        {value || '✨'}
      </ButtonBase>
      <Popover
        open={open}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box p={1.5} maxWidth={340}>
          {EMOJI_GROUPS.map((group) => (
            <Box key={group.label} mb={1.25}>
              <Typography variant="caption" color="text.secondary" sx={{ pl: 0.5 }}>
                {group.label}
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.25}>
                {group.emojis.map((e) => (
                  <ButtonBase
                    key={e}
                    onClick={() => pick(e)}
                    sx={{
                      width: 36,
                      height: 36,
                      fontSize: 22,
                      borderRadius: 1,
                      border: value === e ? '2px solid' : '1px solid transparent',
                      borderColor: value === e ? 'primary.main' : 'transparent',
                      '&:hover': { bgcolor: 'action.hover' },
                    }}
                  >
                    {e}
                  </ButtonBase>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
}
